var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopyCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3611_1341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.48962 13.0006C4.92761 13.0006 3.65625 11.7292 3.65625 10.1672V3.33398H2.48962C1.47827 3.33398 0.65625 4.15588 0.65625 5.16724V14.1672C0.65625 15.1786 1.47827 16.0006 2.48962 16.0006H10.8229C11.8342 16.0006 12.6562 15.1786 12.6562 14.1672V13.0006H6.48962Z",
    fill: "#9CADC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3229 1.83337C15.3229 0.820679 14.5022 0 13.4896 0H6.48962C5.47693 0 4.65625 0.820679 4.65625 1.83337V10.1666C4.65625 11.1793 5.47693 12 6.48962 12H13.4896C14.5022 12 15.3229 11.1793 15.3229 10.1666V1.83337Z",
    fill: "#9CADC4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3611_1341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyCartIcon);
export default __webpack_public_path__ + "static/media/copy-cart-icon.3f75f5cb0cd2d05721ce2dc3707a3ac4.svg";
export { ForwardRef as ReactComponent };